export default "__VITE_ASSET__DGUH5OyN__"